<template>
    <div class="card mb-2">
        <div class="card-body">
            <span class="text-muted" v-if="!bookingSlot.id">
                {{ $t('saving…') }}
            </span>
          <div class="d-flex flex-col justify-content-between align-items-center">
            <a href @click.prevent="showSlotSetting = true">
              {{ startDate }} -> {{ endDate }}
              <span v-if="bookingSlot.recurrence" class="badge badge-success">
                    R
                </span>
            </a>
            <button type="button"
                    class="btn btn-outline-danger"
                    :disabled="bookingSlot.bookings_count > 0"
                    @click="deleteSlot">
              {{ $t('delete') }}
            </button>
          </div>

          <SlotSetting
              :show="showSlotSetting"
              :zone="zone"
              :stage="stage"
              :slot-config="bookingSlot"
              @save-slot="saveSlot($event)"
              @close="showSlotSetting = false"
          >
          </SlotSetting>
        </div>
    </div>
</template>

<script>
    import SlotSetting from './SlotSetting.vue'
    import dayjs from "dayjs";

    export default {
        name: "booking-slot",
        components: {
           SlotSetting,
        },
        props: {
            bookingSlot: {
                type: Object
            },
            slotResourceUrl: {
                type: String,
                required: true,
            },
            zone: {
                default: 'UTC'
            },
            stage: {
                type: Object
            },
        },
        data: function () {
            return {
                showSlotSetting: false,
            }
        },
        computed: {
            startDate() {
                return dayjs(this.bookingSlot.start_at).format('lll');
            },
            endDate() {
              return dayjs(this.bookingSlot.end_at).format('lll');
            },
        },
        methods: {
            saveSlot(slot) {
                var vm = this;
                axios.put(vm.slotResourceUrl + '/' + vm.bookingSlot.id, slot)
                    .then(function (response) {
                        vm.$emit('change', response.data.data);
                    })
                    .catch(function (error) {
                        alert(error.response.data.message)
                    })
                    .finally(() => {
                      vm.showSlotSetting = false;
                    })
            },
            deleteSlot() {
                var vm = this;
                console.log('delete', vm.bookingSlot.id,
                  vm.slotResourceUrl + '/' + vm.bookingSlot.id
                );
                axios.delete(vm.slotResourceUrl + '/' + vm.bookingSlot.id)
                    .then(function (response) {
                        vm.$emit('delete',  vm.bookingSlot.id);
                    })
                    .catch(function (error) {
                        // TODO : Make something with error
                        alert(error.response.data.message)
                    })
            }
        },
    }
</script>

<style scoped>

</style>